import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { FC, useState } from 'react';
import 'react-dadata/dist/react-dadata.css';
import { FormProvider, useForm } from 'react-hook-form';

import { useActions } from '../../../hooks/useActions';
import { useBasket } from '../../../hooks/useBasket';
import { useLocalStorage } from '../../../hooks/useLocalStorage';

import { Address } from './Address';

interface RegisterFormProps {
  onOpenPassword?: any;
  onClose: () => void;
  onOpenRegister?: any;
}

export const AddShippingAddress: FC<RegisterFormProps> = ({ onClose }) => {
  const { setAddAddressValue } = useActions();
  //Состояние "Я заберу заказ"
  const { whereDeliveryTab, addressValue: value } = useBasket();
  //Текст ошибки
  const [error, setError] = useState<string | null>(null);
  const [addressValue, setAddAddressUser] = useLocalStorage('addAddressUser', {
    address: '',
    fullName: '',
    phone: '',
    comment: '',
  });
  const form = useForm({
    mode: 'onChange',
  });

  const onSubmit = (dto: any) => {
    setAddAddressValue(dto);
    setAddAddressUser(dto);
    if (value.address && value.fullName && value.phone) {
      onClose();
      setError(null);
    } else {
      setError('Введите адрес');
      //Сохрание данные в localStorage
    }
  };

  const onChange = (dto: any) => {
    if (value.address && value.fullName && value.phone) {
      setError(null);
    } else {
      setError('Введите адрес');
      //Сохрание данные в localStorage
    }
  };

  return (
    <FormProvider {...form}>
      <div className="add-address">
        <div
          className={
            whereDeliveryTab
              ? 'add-address__wrapper order'
              : 'add-address__wrapper'
          }
        >
          <div className="add-address-top">
            <div className="add-address-top__wrapper">
              <div className="add-address-bottom">
                <h2 className="add-address-top__title">
                  Куда доставить заказ?
                </h2>

                <form
                  onSubmit={form.handleSubmit(onSubmit)}
                  onChange={form.handleSubmit(onChange)}
                >
                  <Address />
                  <div className="add-address-btn_wrapper">
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      className={classNames('add-address-btn', {
                        disabled: error !== null,
                      })}
                      disabled={error !== null}
                    >
                      Добавить
                    </Button>
                  </div>
                </form>
              </div>
              <CloseRoundedIcon
                className="modal__img"
                color="disabled"
                onClick={onClose}
              />
            </div>
          </div>
        </div>
      </div>
    </FormProvider>
  );
};
